import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { FilterMetricsParams } from '../../../../../../../reusables/metric-selector/metric-selector.model';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { GameType } from '../../../../../models/games.model';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';
import { MetricOptions } from 'src/app/gamification/command-center/models/metric-game';
import { MetricSelectorComponent } from '../../../../../../../reusables/metric-selector/metric-selector.component';
import { MetricSelectorService } from '../../../../../../../reusables/metric-selector/metric-selector.service';

@Component({
  selector: 'cv-configure-metric',
  templateUrl: './configure-metric.component.html',
  styleUrls: ['./configure-metric.component.scss']
})
export class ConfigureMetricComponent implements OnInit {
  @Input() step: number;
  @Input() componentOptions: any;

  @Output() componentComplete: EventEmitter<any> = new EventEmitter<any>();
  @Output() onMetricSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRankingData: EventEmitter<any> = new EventEmitter<any>();
  @Input() loading: boolean = false;
  @Output() loadingChange = new EventEmitter<boolean>();

  gs = null;
  metricsSource: string;
  milestoneMetricMessage: boolean;
  //Raffle
  raffleMetricType: string = "";
  metricLeft: string;
  metricRight: string;
  isCxone = false;

  constructor(
    private gamesService: GamesService,
    private cdRef: ChangeDetectorRef,
    public metricSelectorService: MetricSelectorService,
    private formattedMetricPipe: GenericMetricFormatterPipe,
    private cvConfigurationService: CvConfigurationService,
  ) {
    this.gs = this.gamesService.data;
    this.milestoneMetricMessage = false;
  }

  ngOnInit(): void {
    this.gs.modified.item.RaffleLevels = this.gs.modified.item.RaffleLevels || {
      leftNumber: "0",
      rightNumber: "0",
      comparerType: "1"
    };

    if (this.gs.modified.item.SelectedMetrics != undefined) {
      this.initializeRaffleVariables();
    }
    this.isCxone = this.cvConfigurationService.isCxOne;
  }

  initializeRaffleVariables(): void {
    const conversionType = this.gs.modified.item.SelectedMetrics[0].conversionType;

    //Since the backend uses int fields, toString it so the input box will model to it correctly
    this.gs.modified.item.RaffleLevels.comparerType = this.gs.modified.item.RaffleLevels.comparerType.toString();
    this.raffleMetricType = this.getMetricType();

    if (conversionType == 4 || conversionType == 5) {
      this.metricLeft = this.formattedMetricPipe.transform(this.gs.modified.item.RaffleLevels['leftNumber'], conversionType);
      this.metricRight = this.formattedMetricPipe.transform(this.gs.modified.item.RaffleLevels['rightNumber'], conversionType);
    } else {
      this.metricLeft = this.gs.modified.item.RaffleLevels['leftNumber'];
      this.metricRight = this.gs.modified.item.RaffleLevels['rightNumber'];
    }

    this.formatOnBlur('left');
    this.formatOnBlur('right');
  }

  launchMetricSelector(): void {
    let selectedMetric = null;
    if (this.gs.modified.item.SelectedMetrics) {
      const existingMetric = this.gs.modified.item.SelectedMetrics[0];
      selectedMetric =
      {
        mID: existingMetric.metricID,
        mAbr: existingMetric.abbrev,
        mName: existingMetric.name,
        mDir: existingMetric.direction,
        mCT: existingMetric.conversionType,
      };
    }

    //needed to filter metrics based on game type
    this.metricSelectorService.filterParams = this.gamesService.getGameTypeMetricFilter(this.gs.modified.item.definition.GameType);

    const metricSelector = this.metricSelectorService.openModalForSingleMetric(MetricSelectorComponent, selectedMetric);
    const newSelectedMetrics = [];
    metricSelector.result.then((metricSelectorResult) => {
      if (metricSelectorResult) {
        metricSelectorResult?.forEach(m => {
          newSelectedMetrics.push({
            metricID: m.MetricID,
            abbrev: m.Abbreviation,
            name: m.MetricName,
            conversionType: m.ConversionType,
            direction: m.DefaultDirection,
          });
        });
        this.gs.modified.item.SelectedMetrics = newSelectedMetrics;
        this.onMetricClicked(newSelectedMetrics[0]);
      }
    });
  }

  private async onMetricClicked(newMetric) {
    //Clean Message
    this.milestoneMetricMessage = false;

    var eventArgs = {
      currentStep: this.step - 1,
      unlocks: this.componentOptions.unlocks
    };

    //Milestone Metric Check
    if (this.gs.modified.item.definition.GameType == 5) {
      if (this.gs.modified.item.SelectedMetrics[0].direction == 1 && this.gs.modified.item.SelectedMetrics[0].conversionType == "0") {
        this.componentComplete.emit(eventArgs);
      } else {
        //Show Message
        this.milestoneMetricMessage = true;
      }
    } else if (this.gs.modified.item.definition.GameType == 9) {
      this.raffleMetricType = this.getMetricType();
      this._resetAndFormatFields();
      this.componentComplete.emit(eventArgs);
    } else {
      this.componentComplete.emit(eventArgs);
    }
 
    this.onMetricSelected.emit({
      mID: newMetric.metricID,
      mAbr: newMetric.abbrev,
      mName: newMetric.name,
      mDir: newMetric.direction,
      mCT: newMetric.conversionType,
    });
    this.cdRef.detectChanges();

    if (this.gs.modified.item.definition.GameType == 10) {
      this.loadingChange.emit(true);
      let ranking = await this.gamesService.LoadMetricRanking(newMetric.metricID, this.gs.modified.item.Eligibility.AssignedGroups.emp);
      ranking.RowData.forEach(row => {
        row.MetricName = newMetric.abbrev;
      });
      this.emitRankingData(ranking.RowData);
      this.loadingChange.emit(false); 
    }
  }

  getLocalizedMessage(key: string, value: string): string {
    return this.gamesService.getMilestoneGameMessages(key, value);
  }

  // Handle the metric changes on Raffle games
  getMetricType(): string {
    if (this.gs.modified != null && this.gs.modified.item != null && this.gs.modified.item.SelectedMetrics[0] != null) {
      switch (this.gs.modified.item.SelectedMetrics[0].conversionType) {
        case "1": return "sec";
        case "2": return "min";
        case "3": return "hr";
        case "4": return "time";
        case "5": return "%";
      }
    }

    return "";
  }

  formatOnBlur(side: string): void {
    let property = side == 'left' ? 'leftNumber' : 'rightNumber';
    let setTo: number | string = side == 'left' ? this.metricLeft : this.metricRight;
    const conversionType = this.gs.modified.item.SelectedMetrics[0].conversionType;

    if (conversionType == 4)
      setTo = this.getTimeInSeconds(setTo.toString());
    else if (conversionType == 5) {
      setTo = side == 'left' ? +this.metricLeft / 100 : +this.metricRight / 100;
    }
    setTimeout(() => {
      this.gs.modified.item.RaffleLevels[property] = this.gs.modified.item.RaffleLevels[property] == 1 ? 0 : 1; //set the value to something it is not set to right now.
      setTimeout(() => {
        this.gs.modified.item.RaffleLevels[property] = setTo;

        if (side == 'left')
          this.metricLeft = this.formattedMetricPipe.transform(+setTo, conversionType);
        else
          this.metricRight = this.formattedMetricPipe.transform(+setTo, conversionType);
      }, 0);
    }, 0);
  }

  _resetAndFormatFields(): void {
    const _zero = this.formattedMetricPipe.transform(0, this.gs.modified.item.SelectedMetrics[0].conversionType);

    this.gs.modified.item.RaffleLevels.leftNumber = 0;
    this.gs.modified.item.RaffleLevels.rightNumber = 0;

    this.metricLeft = _zero;
    this.metricRight = _zero;

    this.formatOnBlur('left');
    this.formatOnBlur('right');
  }

  getTimeInSeconds(value: string) {
    const valueSplited = value.split(":").map(v => +v);
    let i = valueSplited.length - 3;

    const hour = +valueSplited[i] || 0;
    const minutes = +valueSplited[++i] || 0;
    const seconds = +valueSplited[++i] || 0;
    return hour * 3600 + minutes * 60 + seconds;
  }

  emitRankingData(rankingData: any) {
    this.onRankingData.emit(rankingData);
  }

  changeLoading(newValue: boolean) {
    this.loadingChange.emit(newValue);
  }

}
